import { FC } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses.ts';

export interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 32, className = '' }) => {
  return (
    <div
      className={mergeClasses(
        'spinner inline-block animate-spin-fast rounded-full border-2 border-primary-500 border-b-transparent border-l-transparent',
        className,
      )}
      style={{
        width: size,
        height: size,
      }}
    />
  );
};
